import { ApiError, isNetworkError, isTransientAuthError, TimeoutError } from '@platform/api';

/**
 * The app's single query-retry policy. Separate from the QueryClient so the auth
 * gate cannot end up on a different policy than every other query, and so tests
 * can exercise the real one.
 */
export function retryPolicy(failureCount: number, error: Error): boolean {
  // Never retry 4xx/5xx from our own BFF. A 401 is handled in the fetch layer
  // (registerUnauthorizedHandler) and stays pending until login navigation lands.
  if (error instanceof ApiError) {
    return false;
  }
  if (error instanceof TimeoutError) {
    return false;
  }
  // Session survived (IdP briefly unreachable), so ride it out.
  if (isTransientAuthError(error)) {
    return failureCount < 3;
  }
  if (isNetworkError(error)) {
    return failureCount < 1;
  }
  // Unclassified means a bug, not a flaky transport: retrying only hides it.
  return false;
}
